import React, { useState } from 'react';
import { FormattedMessage } from "react-intl";

import Config from "../../config";
import { triggerTestSaveQuoteFailure } from "../../misc/errorReporting/testSaveFailure";
import { triggerTestExtensionError } from "../../misc/errorReporting/testExtensionError";

const DevToolsPanel = () => {
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  const [shouldCrashApp, setShouldCrashApp] = useState(false);
  const canShowFatalErrorTestButton = Config.isDevMode() || Config.isDemo() || document.kvConfig.demoMode;

  if (shouldCrashApp) {
    throw new Error('Desktop header demo fatal error test');
  }

  if (!canShowFatalErrorTestButton) {
    return null;
  }

  return (
    <div className="dev-tools">
      <button className={"dev-tools__toggle" + (devToolsOpen ? " dev-tools__toggle--open" : "")}
              title="Developer tools"
              onClick={() => setDevToolsOpen(!devToolsOpen)}>
        DEV
      </button>
      {devToolsOpen ? (
        <div className="dev-tools__panel">
          <button className="dev-tools__button"
                  title="Trigger fatal error (dev only)"
                  onClick={() => setShouldCrashApp(true)}>
            <svg className="dev-tools__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <FormattedMessage id="debug.fatalErrorTestButton"/>
          </button>
          <button className="dev-tools__button"
                  title="Force a real 403 on save (dev only)"
                  onClick={triggerTestSaveQuoteFailure}>
            <svg className="dev-tools__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17 21 17 13 7 13 7 21"/>
              <polyline points="7 3 7 8 15 8"/>
            </svg>
            <FormattedMessage id="debug.forceSaveQuoteFailButton"/>
          </button>
          <button className="dev-tools__button"
                  title="Trigger a fake browser-extension error (dev only)"
                  onClick={triggerTestExtensionError}>
            <svg className="dev-tools__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.91 8.84L8.56 21.18a2.01 2.01 0 0 1-2.83 0l-2.9-2.9a2.01 2.01 0 0 1 0-2.83L15.16 3.1a1.5 1.5 0 0 1 2.12 0l3.63 3.63a1.5 1.5 0 0 1 0 2.11z"/>
              <path d="M9 5l1 1"/>
              <path d="M17 13l1 1"/>
            </svg>
            <FormattedMessage id="debug.extensionErrorTestButton"/>
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default DevToolsPanel;
